// extracted by css-extract-rspack-plugin
export default {"avatar":"avatar-tT6RDm","image":"image-FyKide"};